import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import GraphicsList from "./GraphicsList";
import OverPass from "./OverPass";
import SketchTools from "./SketchTools";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ConfirmInfo from "./ConfirmInfo";
import LoadingButton from "./LoadingButton";
import ManageResults from "./ManageResults";
import WidgetComponent from "./WidgetComponent";
//import OptionsComponent from "./OptionsComponent";

interface SpatialAnalysisComponentProps {
  map?: Map;
  view: MapView;
}

export const SpatialAnalysisComponent: React.FC<
  SpatialAnalysisComponentProps
> = ({ map, view }) => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [startSearch, setStartSearch] = useState<boolean>(false);
  const [height, setHeight] = useState<number>(200);

  //TODO
  //add here a search and data from url

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get("search") === "true";
    if (!value) return;
    setTimeout(() => {
      setStartSearch(value);
    }, 1000);
  }, []);

  const accordionQueryRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setHeight(window.innerHeight - entry.contentRect.height - 120);
      }
    });

    if (accordionQueryRef.current) {
      observer.observe(accordionQueryRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <WidgetComponent
      header={() => {
        return (
          <LoadingButton
            width="80px"
            loading={loading}
            onClickAction={() => {
              setStartSearch(true);
              setTimeout(() => {
                setStartSearch(false);
              }, 1000);
            }}
          ></LoadingButton>
        );
      }}
    >
      <div
        id="turboComponent"
        ref={containerRef}
        style={{
          background: "white",
          width: "300px",
          height: "95vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Accordion defaultExpanded ref={accordionQueryRef}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panelQuery"
          >
            <Typography component="span">Query</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <ConfirmInfo
                text="Create query and click SEARCH"
                keyId="createKey"
              ></ConfirmInfo>
              <OverPass
                map={map}
                view={view}
                onLoading={(load) => setLoading(load)}
                startSearch={startSearch}
              ></OverPass>

              <Accordion style={{ marginTop: "5px" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panelManageResult"
                  id="panelManageResult"
                >
                  <Typography component="span">Manage result</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <SketchTools map={map} view={view}></SketchTools>
                  <ManageResults map={map} view={view}></ManageResults>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panelManageResult"
                  id="panelOptions"
                >
                  <Typography component="span">Options</Typography>
                </AccordionSummary>
                <AccordionDetails>
                 {/*  <OptionsComponent></OptionsComponent> */}
                </AccordionDetails>
              </Accordion>
            </div>
          </AccordionDetails>
        </Accordion>

        <GraphicsList map={map} view={view} height={height}></GraphicsList>
      </div>
    </WidgetComponent>
  );
};

export default SpatialAnalysisComponent;
